import { Component, OnInit } from '@angular/core';
//import * as Chart from 'chart.js';
import { DataStorageService } from '../../shared/data-storage.service';
import { NGXLogger } from 'ngx-logger';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { LeftMenu } from '../../shared/leftmenu/LeftMenu';
import { LoaderService } from '../../shared/loader/loader.service';
//import { AdminDashboardService } from '../admin-dashboard/admin-dashboard.service';
//import { ViewAdminDashboardResponse, ViewAdminTxnsDashboardGraphDataResponse, ViewAdminDashboard, AdminPaymentKeyperFormanceIndicatorView, AdminTxnsStaticsView, AdminTxnsRegBillerView, BillerPerformance, AdminPaymentSuccessRateView, TopBillerResp, AdminPaymentTxnsAmountViewResp, AdminPaymentTxnsAmountView, TopBiller } from '../admin-dashboard/view-admin-dashboard';
import { GrsDashboard, GRSComplaintDetails, GRSDisputeDetails, GRSTicketDetails, ModeWiseComplain, ModeWiseComplainView, AgentPerformanceReport, AgentPerformanceReportData, AgentPerformanceReportView, TatComplaintView, TatComplaintData } from './grs-view';
import { Ekpayuser } from '../../user/user';
import { GrsDashboardService } from './grs-dashboard.service';
import { TranslateService } from '../../../../node_modules/@ngx-translate/core';
import { Subscription } from '../../../../node_modules/rxjs';
import { User } from '../../shared/auth/user';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-grs-admin-dashboard',
  templateUrl: './grs-admin-dashboard.component.html',
  styleUrls: ['./grs-admin-dashboard.component.css']
})
export class GrsAdminDashboardComponent implements OnInit {
  dataTextForTAT: string;
  dataTextForPerf: string;
  loaderOff: number;
  grsDashboard: GrsDashboard;
  user: User;
  gRSComplaintDetails: GRSComplaintDetails;
  gRSDisputeDetails: GRSDisputeDetails;
  gRSTicketDetails: GRSTicketDetails;
  modeWiseComplain: ModeWiseComplain;
  modeWiseComplainView: ModeWiseComplainView;
  agentPerformanceReportData: AgentPerformanceReportData;
  agentPerformanceReportView: AgentPerformanceReportView;
  tatComplaintView: TatComplaintView;
  tatComplaintData: TatComplaintData;
  activeAllFlag: boolean = false;
  activeYearFlag: boolean = false;
  activeMonthFlag: boolean = false;
  activeWeekFlag: boolean = false;
  activeTodayFlag: boolean = false;
  textHeading: string;
  isGetGRSComplaint: boolean = false;
  isGetGRSTicket: boolean = false;
  isGetGRSDispute: boolean = false;
  isGetModelwiseComp: boolean = false;
  isGetAgentPerReport: boolean = false;
  isGetTATMatrix: boolean = false;
  subscription: Subscription;
  lang: string;
  isRecentTransaction: boolean = false;
  isAgentPerformDataNotPresent: boolean = false;

  isNotErrorInComplaintApi: boolean = false;
  complaintTxt: string;
  isNotErrorInTicketApi: boolean = false;
  ticketTxt: string;
  isNotErrorInDisputeApi: boolean = false;
  disputeTxt: string;
  isNotErrorInModeApi: boolean = false;
  modeTxt: string;
  constructor(private dataStorageService: DataStorageService,
    private serviceGrs: GrsDashboardService,
    private logger: NGXLogger,
    private router: Router,
    private pipe: DatePipe, private leftMenu: LeftMenu,
    private readonly translate: TranslateService

  ) { }

  ngOnInit() {
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      //this.logger.debug('data lang is ' + data);
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      this.translate.use(this.lang);
    })
    window.scroll(0, 0);
    this.user = new User();
    this.user = JSON.parse(localStorage.getItem("sessuser"));
    this.grsDashboard = new GrsDashboard();
    this.gRSDisputeDetails = new GRSDisputeDetails();
    this.gRSComplaintDetails = new GRSComplaintDetails();
    this.modeWiseComplain = new ModeWiseComplain();
    this.gRSTicketDetails = new GRSTicketDetails();
    this.tatComplaintData = new TatComplaintData();
    this.tatComplaintView = new TatComplaintView();
    this.agentPerformanceReportView = new AgentPerformanceReportView();
    this.agentPerformanceReportData = new AgentPerformanceReportData();
    if (this.user != undefined) {
      this.getTodayWeekMonthYearDate('today');
    }

  }
  getTodayWeekMonthYearDate(valTime) {
    //  this.isDataRefresh = false;
    let todayFrmtdDate = this.pipe.transform(new Date(), 'yyyy-MM-dd');
    // -----------------------week start n end date--------------

    let first1 = new Date().getDate() - new Date().getDay();
    let last1 = first1 + 6;
    let ws = new Date(new Date().setDate(first1));
    let weekStartDate = this.pipe.transform(ws, 'yyyy-MM-dd');
    let wl = new Date(new Date().setDate(last1));
    let weekLastDate = this.pipe.transform(wl, 'yyyy-MM-dd');

    // -----------------------month and start n end date--------------
    let monStrt = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    let monthStartDate = this.pipe.transform(monStrt, 'yyyy-MM-dd');
    let monEnd = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    let monthLastDate = this.pipe.transform(monEnd, 'yyyy-MM-dd');
    let yStrt = new Date(new Date().getFullYear(), 0, 1);
    let yearStartDate = this.pipe.transform(yStrt, 'yyyy-MM-dd');
    let yEnd = new Date(new Date().getFullYear(), 11, 31);
    let yearEndDate = this.pipe.transform(yEnd, 'yyyy-MM-dd');


    if (valTime == 'all') {
      this.activeAllFlag = true;
      this.activeYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.grsDashboard.from_date = yearStartDate;
      this.grsDashboard.to_date = todayFrmtdDate;
      this.textHeading = "All";
    } else if (valTime == 'year') {
      this.activeAllFlag = false;
      this.activeYearFlag = true;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.grsDashboard.from_date = yearStartDate;
      this.grsDashboard.to_date = yearEndDate;
      this.textHeading = "This year's";
    }
    else if (valTime == 'month') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeMonthFlag = true;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.grsDashboard.from_date = monthStartDate;
      this.grsDashboard.to_date = monthLastDate;
      this.textHeading = "This month's";
    }
    else if (valTime == 'week') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = true;
      this.activeTodayFlag = false;
      this.grsDashboard.from_date = weekStartDate;
      this.grsDashboard.to_date = weekLastDate;
      this.textHeading = "This week's";
    }
    else if (valTime == 'today') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = true;
      // this.viewAdminDashboard.datafor = "today";
      this.grsDashboard.from_date = todayFrmtdDate;
      this.grsDashboard.to_date = todayFrmtdDate;
      this.textHeading = "Today's";
    }
    //   this.grsDashboard.id = this.user.user_type=='Admin' || this.user.user_type=='GRS Admin User' ? 'all':this.user.user_id;
    this.grsDashboard.id = this.user.user_id;
    this.getGRSComplaintView();
    this.getGRSTicketView();
    this.getGRSDisputeView();
    this.getModeWiseComplaint();
    this.getAgentPerformanceReport();
    this.getComplaintTATMatrix();
  }

  getGRSComplaintView() {
    this.isGetGRSComplaint = false;
    this.serviceGrs.getGRSComplaintView(this.grsDashboard).subscribe((data) => {
      this.gRSComplaintDetails = data.body as GRSComplaintDetails;
      this.isGetGRSComplaint = true;
    },
      (err) => {
        this.isNotErrorInComplaintApi = true;
        this.complaintTxt = "Unable to fetch data";
      });
  }

  getGRSTicketView() {
    this.isGetGRSTicket = false;
    this.serviceGrs.getGRSTicketView(this.grsDashboard).subscribe((data) => {
      this.gRSTicketDetails = data.body as GRSTicketDetails;
      this.isGetGRSTicket = true;
    },
      (err) => {
        this.isNotErrorInTicketApi = true;
        this.ticketTxt = "Unable to fetch data";
      });

  }

  getGRSDisputeView() {
    this.isGetGRSDispute = false;
    this.serviceGrs.getGRSDisputeView(this.grsDashboard).subscribe((data) => {
      this.gRSDisputeDetails = data.body as GRSDisputeDetails;
      this.isGetGRSDispute = true;

    },
      (err) => {
        this.isNotErrorInDisputeApi = true;
        this.disputeTxt = "Unable to fetch data";
      });
  }

  public lineTransactionChartData: Array<any>;
  //  = [
  //   { data: [13, 12, 11, 5, 7, 12, 13, 53, 70, 100, 150], label: 'Transactions' },
  // ];
  public lineTransactionChartLabels: Array<any>;
  //= ['02 00:00', '02 01:00', '02 02:00', '02 03:00', '02 04:00', '02 05:00', '02 06:00', '02 07:00', '02 08:00', '02 09:00', '02 10:00'];
  public lineTransactionChartLegend: boolean = true;
  public lineTransactionChartType: string = 'bar';
  public lineTransactionChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    spanGaps: true,
    fill: false,
    scales:
    {
      xAxes: [{
        maxRotation: 90,
        ticks: {
        }
      }],
      yAxes:
        [
          {
            scaleLabel: { display: true, labelString: 'No. of Complaints', fontSize: 16, fontColor: '#9c3f90' },
            ticks: { min: 0, beginAtZero: true, fontSize: 13 }
          }
        ]
    }
  };
  getModeWiseComplaint() {
    this.isGetModelwiseComp = false;
    this.modeWiseComplain.from_date = this.grsDashboard.from_date;
    this.modeWiseComplain.to_date = this.grsDashboard.to_date;
    this.modeWiseComplain.id = this.grsDashboard.id;
    // alert(this.modeWiseComplain.id);
    this.serviceGrs.getModeWiseComplaint(this.modeWiseComplain).subscribe((data) => {
      //this.logger.debug("GRS ..............call" + JSON.stringify(data.body));
      this.modeWiseComplainView = data.body as ModeWiseComplainView;
      this.lineTransactionChartData = [
        { data: this.modeWiseComplainView.mode_count, label: 'No. of Complaints' },
      ];
      this.isGetModelwiseComp = true;
      this.lineTransactionChartLabels = this.modeWiseComplainView.mode_name;
    },
      (err) => {
        this.isNotErrorInModeApi = true;
        this.modeTxt = "Unable to fetch data";
      });

  }
  public lineTrancationChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(136,193,51,0.4)',
      borderColor: 'rgba(136,193,51,1)',
      pointBackgroundColor: 'rgba(136,193,51,1)',
      pointBorderColor: 'rgba(136,193,51,1)',
      pointHoverBackgroundColor: '#rgba(136,193,51,1)',
      pointHoverBorderColor: '#rgba(136,193,51,1)'
    },
  ];

  getAgentPerformanceReport() {
    this.isGetAgentPerReport = false;
    this.isAgentPerformDataNotPresent = false;
    this.agentPerformanceReportData.start_date = this.grsDashboard.from_date;
    this.agentPerformanceReportData.end_date = this.grsDashboard.to_date;
    this.agentPerformanceReportData.mode = 'web';
    this.agentPerformanceReportData.user_id = this.grsDashboard.id;
    this.serviceGrs.getAgentPerformanceReport(this.agentPerformanceReportData).subscribe((data) => {
      this.agentPerformanceReportView = data.body as AgentPerformanceReportView;
      this.isGetAgentPerReport = true;
      if (this.agentPerformanceReportView.agent_performance_report == null) {
        this.isAgentPerformDataNotPresent = true;
        this.dataTextForPerf = "No Data Found";
      }
    },
      (err) => {
        this.isAgentPerformDataNotPresent = true;
        this.dataTextForPerf = "Unable to fetch data";
        //this.logger.debug('exceptin occured...' + JSON.stringify(err));
        //this.logger.debug('this.tatComplaintView...' + JSON.stringify(this.agentPerformanceReportView));
      });
  }

  getComplaintTATMatrix() {
    this.isRecentTransaction = false;
    this.isGetTATMatrix = false;
    this.tatComplaintData.from_date = this.grsDashboard.from_date;
    this.tatComplaintData.to_date = this.grsDashboard.to_date;
    this.tatComplaintData.id = this.grsDashboard.id;
    this.serviceGrs.getComplaintTATMatrix(this.tatComplaintData).subscribe((data) => {
      this.tatComplaintView = data.body as TatComplaintView;
      this.isGetTATMatrix = true;
      if (this.tatComplaintView.complaint_tat_matrix == null) {
        this.isRecentTransaction = true;
        this.dataTextForTAT = "No data found";
      }
    }, (err) => {
      this.isRecentTransaction = true;
      this.dataTextForTAT = "Unable to fetch data";
      //this.logger.debug('exceptin occured...' + JSON.stringify(err));
      //this.logger.debug('this.tatComplaintView...' + JSON.stringify(this.tatComplaintView));
    });
  }
}
// ,
//       (error) => {
//         //console.log(error);
//         alert("error occured..." + error);
//       }



// WEBPACK FOOTER //
// ./src/app/dashboards/grs-admin-dashboard/grs-admin-dashboard.component.ts